import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiCacheService } from './api-cache.service';
import {ApiResponse} from "../../models/ApiResponse";

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  baseUrl = environment.apiUrl;
  headers = new HttpHeaders({});

  constructor(private http: HttpClient, private apiCacheService: ApiCacheService ) {
  }

  getData(url: string, data?: any, backGroundUrl?: boolean): Observable<any> {
    let searchParams = new HttpParams();
    for (const key in data) {
      searchParams = searchParams.append(key, data[key]);
    }

    const apiUrl = `${this.baseUrl}${url}`;
    return this.http.get<any>(apiUrl, { params: searchParams })
  }

  getDataWithCache(url: string, data?: any, backGroundUrl?: boolean, skipCache: boolean = false): Observable<any> {
    const apiUrl = `${this.baseUrl}${url}`;

    const cachedData = this.apiCacheService.get(apiUrl);
    if (!skipCache && cachedData) {
      return of(cachedData);
    }
    else {
      return this.getData(url, data, backGroundUrl).pipe(
        (map(response => {
          this.apiCacheService.set(apiUrl, response)
          return response
        }))
      )
    }
  }

  get(url: string, data?: any, backGroundUrl?: boolean): Observable<any> {
    let searchParams = new HttpParams();
    for (const key in data) {
      searchParams = searchParams.append(key, data[key]);
    }
    const apiUrl = url;
    return this.http.get<any>(apiUrl, { params: searchParams });
  }

  postData(url: string, data: any, formData?: boolean) {
    const apiUrl = `${this.baseUrl}${url}`;
    const postData = !formData ? data : this.appendFormData(data);
    return this.http.post<any>(apiUrl, postData, { headers: this.headers });
  }

  putData<T>(url: string, data: any, formData?: boolean) {
    const apiUrl = `${this.baseUrl}${url}`;
    const postData = !formData ? data : this.appendFormData(data);
    // return this.http.put<ApiResponse<T>>(apiUrl, postData); //TODO will use this when API updated
    return this.http.put<any>(apiUrl, postData);
  }

  patchData(url: string, data: any, formData?: boolean) {
    const apiUrl = `${this.baseUrl}${url}`;
    const postData = !formData ? data : this.appendFormData(data);
    return this.http.patch<any>(apiUrl, postData);
  }

  deleteData(url: string, data?: any, formData?: boolean) {
    const apiUrl = `${this.baseUrl}${url}`;
    // const postData = !formData ? data : this.appendFormData(data);
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: data || formData
    };
    return this.http.delete<any>(apiUrl, options);
  }

  getFile(url: string, data?: any, backGroundUrl?: boolean) {
    const apiUrl = `${this.baseUrl}${url}`;
    return this.http.get(apiUrl,{responseType:'blob'});
  }

  appendFormData(myFormData: { [x: string]: any; }): FormData {
    const fd = new FormData();
    for (const key in myFormData) {
      if (myFormData[key]) {
        fd.append(key, myFormData[key]);
      }
    }
    return fd;
  }
}
